import { Component, Input, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { AdminService } from '../../services/admin.service';

@Component({
    selector: 'app-thermometer',
    templateUrl: './thermometer.component.html',
    styleUrls: ["./thermometer.component.css"]
})
export class ThermometerComponent {

    @Input() dataListVector;
    name = 'Angular 6';
    canvas: any;
    ctx: any;
    @ViewChild('mychart') mychart;
    data = [];
    datasets = [];

    constructor() {}

    ngOnInit() {
        this.getGeneralNotify(this.dataListVector);
    }

    getGeneralNotify(datas) {
        this.data = datas;
        this.data.forEach((element, index) => {
            if (new Date(element.data + 'T00:00:00').getMonth() == 0) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "January",
                    fill: false,
                    borderColor: '#9bfc1a',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 1) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "February",
                    fill: false,
                    borderColor: '#fc1a9b',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 2) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "March",
                    fill: false,
                    borderColor: '#1a9bfc',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 3) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "April",
                    fill: false,
                    borderColor: '#1afcec',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 4) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "May",
                    fill: false,
                    borderColor: '#1a2afc',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 5) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "June",
                    fill: false,
                    borderColor: '#fc7b1a',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 6) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "July",
                    fill: false,
                    borderColor: '#7e3e0d',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 7) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "August",
                    fill: false,
                    borderColor: '#0d7e77',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 8) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "September",
                    fill: false,
                    borderColor: '#7e0d4d',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 9) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "October",
                    fill: false,
                    borderColor: '#0d4d7e',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 10) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "November",
                    fill: false,
                    borderColor: '#b6b8d8',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
            if (new Date(element.data + 'T00:00:00').getMonth() == 11) {
                let dataList = [{ x: 0, y: 0 }]
                let obj = {
                    x: element.x,
                    y: element.y
                }
                dataList.push(obj);
                let el = {
                    label: "December",
                    fill: false,
                    borderColor: '#c9d8b6',
                    borderWidth: index <= 2 ? 2 : index - 2,
                    data: dataList
                }
                this.datasets.push(el);
            }
        })
        this.ngAfterViewInit();
    }

    ngAfterViewInit() {
        this.canvas = this.mychart.nativeElement;
        this.ctx = this.canvas.getContext('2d');

        let myChart = new Chart(this.ctx, {
            type: 'line',
            data: {
                datasets: this.datasets
            },
            options: {
                responsive: false,
                maintainAspectRatio: false,
                animation: {
                    duration: 0
                },
                hover: {
                    animationDuration: 0
                },
                responsiveAnimationDuration: 0,
                title: {
                    display: true,
                    text: ''
                },
                scales: {
                    xAxes: [{
                        type: 'linear',
                        position: 'bottom',
                        ticks: {

                        },
                        scaleLabel: {
                            labelString: '',
                            display: true,
                        }
                    }],
                    yAxes: [{
                        type: 'linear',
                        ticks: {

                        },
                        scaleLabel: {
                            labelString: '',
                            display: true
                        }
                    }]
                }
            }
        });
        myChart.update();
    }
}    


// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/thermometer/thermometer.component.ts